<template>
    <journey-connection-property-base 
        :label="label"
        forInput="ConnectionDisabled"
    >
        <toggle 
            v-model="model" 
            :sync="true" 
            :labels="{checked: resource('Bool_Yes'), unchecked: resource('Bool_No')}"
            :width="50"
        />
    </journey-connection-property-base>
</template>

<script>
    import JourneyConnectionPropertyBase from "./JourneyConnectionPropertyBase.vue";
    import resources from '../../../../../Util/Mixins/resources';
    import { ToggleButton } from 'vue-js-toggle-button';

    export default {
        name: 'journey-connection-toggle',
        mixins: [resources],
        components: {
            JourneyConnectionPropertyBase,
            'Toggle': ToggleButton
        },
        computed: {
            model: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        props: {
            value: {
                type: Boolean,
                required: true
            },
            label: {
                type: String,
                default: ''
            }
        }
    }
</script>